<template>
  <div>
    <div>
      <!--FECHA ETA -->
      <div
        v-if="despacho.tipo.fecha_eta && estados.fecha_eta"
        class="grid grid-cols-5 gap-4"
      >
        <div>
          <p>Fecha Eta</p>
        </div>
        <div class="col-span-3 text-right uppercase font-bold">
          <p v-if="despacho.tipo.fecha_eta">
            {{ moment(despacho.tipo.fecha_eta).format("DD-MM-YYYY") }}
          </p>
          <p v-else>-</p>
        </div>
        <div class="mx-auto">
          <button
            @click="editar('operaciones', 'fecha_eta')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
        </div>
      </div>
      <div v-else class="grid grid-cols-2 gap-4 p-4">
        <div>
          <label> Fecha ETA </label>
          <input type="date" v-model="fecha_eta" required />
        </div>
        <div class="flex flex-row items-center gap-2 mt-auto">
          <button
            class="btn-principal"
            type="button"
            @click="
              editar('operaciones', 'fecha_eta', true, {
                fecha_eta: fecha_eta,
              })
            "
          >
            Guardar
          </button>
          <button
            class="btn-secundario"
            type="button"
            @click="editar('operaciones', 'fecha_eta')"
          >
            Cancelar
          </button>
        </div>
      </div>

      <!--Transporte -->
      <div v-if="despacho.transporte && estados.transporte" hidden>
        <div>
          <p>Transporte</p>
        </div>
        <div>
          <p v-if="despacho.transporte">
            {{ despacho.transporte }} - {{ despacho.correo_transporte }}
          </p>
          <p v-else>-</p>
        </div>
        <div hidden>
          <button
            v-if="pantalla == true"
            @click="editar('operaciones', 'transporte')"
            class="btn-principal"
          >
            Editar
            <fas :icon="['fas', 'edit']" />
          </button>
          <button
            v-if="pantalla == false"
            @click="editar('operaciones', 'transporte')"
            class="btn-principal-chico"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/EditarAzul.svg"
              title="My Image"
            />
          </button>
        </div>
      </div>

      <div v-else hidden>
        <div>
          <form class="form-input">
            <div>
              <div sm="12" md="12" lg="4">
                <b-form-group
                  class="text-left"
                  label="Nombre de Transporte Local (Chile) "
                  label-for="transporte-select"
                >
                  <input type="text" v-model="transporte" required> </input>
                </b-form-group>
              </div>
              <div sm="12" md="12" lg="4">
                <b-form-group
                  class="text-left"
                  label="Correo de Transporte Local"
                  label-for="correo_transporte-select"
                >
                  <input type="email" v-model="correo_transporte" required>
                  </input>
                </b-form-group>
              </div>

              <div sm="12" md="12" lg="4">
                <button
                  class="btn-principal"
                  type="button"
                  @click="
                    editar('operaciones', 'transporte', true, {
                      transporte: transporte,
                      correo_transporte: correo_transporte,
                    })
                  "
                >
                  Guardar
                </button>
                <button
                  class="btn-secundario"
                  type="button"
                  @click="editar('operaciones', 'transporte')"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import InputRut from "../InputRut.vue";
import InputRegion from "../InputRegion.vue";
export default {
  components: { InputRut, InputRegion },
  name: "FormUsuario",

  props: {
    despacho: Object,
    postInformacionGeneral: Function,
    informacionGeneral: Object,
    editar: Function,
    estados: Object,
  },
  emits: ["update-arrival-date"],
  data() {
    return {
      nombre: "",
      nombre_transporte: "",
      cliente_id: 0,
      fecha_eta: "",
      transporte: "",
      aduana_id: "",

      transporte: "",
      correo_transporte: "",
      pantalla: false,
    };
  },
  mounted() {
    if (screen.width <= 660) this.pantalla = false;
    else this.pantalla = true;
  },
  methods: {
    cambiarRut(value) {
      this.cliente_rut = value;
    },
    cambiarRutTransporte(value) {
      this.transporte = value;
    },
  },
};
</script>
